<template>
  <div class="rules">
    <navbar leftText show-home title="会员规则"></navbar>
    <div class="rules-wrapper">
      <p>
        云南联通PLUS权益商城为向核心客户提供更优质的体验，特别推出云南联通PLUS权益会员。云南联通PLUS权益会员权益包含购物返福利金、品牌出厂价、退换无忧、专属客服、专享权益，同时云南联通PLUS权益会员还享受更优惠的抄底价购物，全方位提升和丰富您的特权生活。
      </p>
      <p>
        我们希望通过会员制与您建立长期的双赢关系，同时我们将不断丰富会员权益，为您提供更完善的服务，期待您与我们携手打造更好的体验！
      </p>
      <p>
        更多更加省钱的购物：账户里多了很多福利金？这是因为在您的日常购物中，多数订单都会得到返还福利金，不知不觉中您就会积累一笔小财富。
      </p>
      <p>
        更加全面优惠的权益：会员专享诸多权益，涵盖生活的方方面面，商旅、教育、视听、游戏、知识、保险、生活周边、车主等特有权益，为您优选特惠。
      </p>
      <p>
        专线接听解答：为您开启专业的客服专线，时刻待命为您解疑会员制度、售后处理。客服电话：400-6687017。
      </p>
    </div>
  </div>
</template>

<script>
import Navbar from '../components/NavBar'
export default {
  name: 'rules',
  components: {
    Navbar
  }
}
</script>

<style lang="less" scoped>
.rules {
  .rules-wrapper {
    padding: 0.7rem 0.45rem;
    font-size: @fz32;
    color: @base;
    line-height: 1.4;
    font-weight: 600;
    p {
      text-indent: 2em;
      line-height: 1.6;
    }
  }
}
</style>
